import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, Renderer2 } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs/internal/Observable";
import { finalize } from "rxjs/operators";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { DataPredioDireccion } from "src/app/models/data-predio-direccion";
import { OptionsTransportDteEmitido } from "src/app/models/Dte/OptionsTransportDteEmitido";
import { TipoDespachoEnum } from "src/app/models/Dte/TipoDespacho.enum";
import { TotalDteEmitido } from "src/app/models/Dte/TotalDteEmitido";
import { Comuna } from "src/app/models/Region/Comuna";
import { StandardResponse } from "src/app/models/StandardResponseAPI";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { MapaService } from "src/app/services/mapa.service";
import { environment } from "src/environments/environment";

@Component({
	selector: "app-item-transporte-dte",
	templateUrl: "./item-transporte-dte.component.html",
	styleUrls: ["./item-transporte-dte.component.scss"],
})
export class ItemTransporteDteComponent implements OnInit {
	@Output() loadingChange = new EventEmitter<boolean>(); // Emisor de eventos para el estado de carga

	private totalesDteObservable$: Observable<TotalDteEmitido>;
	public tipoDespacho: TipoDespachoEnum;
	public transporteGroupForm: FormGroup;
	mapaEmbedUrl: SafeResourceUrl | null = null;
	direccionMapa: string = "";

	comunas: Comuna[] = [];

	informacionGeografica: DataPredioDireccion | null = null;
	multiplePredios: DataPredioDireccion[] = [];
	showPrediosTable: boolean = false;
	showManualForm: boolean = false;
	isLoading: boolean = false;
	submitted: boolean = false;

	latitudMapa: number | null = null;
	longitudMapa: number | null = null;

	mostrarManejoMadera: boolean = false;
	public clicked: boolean = false;
	public optionsTransport: OptionsTransportDteEmitido = new OptionsTransportDteEmitido();
	constructor(private builder: FormBuilder, private _renderer: Renderer2, private sanitizer: DomSanitizer, private modalService: NgbModal, private ref: ChangeDetectorRef, private facturador: FacturacionIndividualService, private mapaService: MapaService) {
		this.totalesDteObservable$ = this.facturador.resumenTotalesObservable;
	}

	clickedAccordionButton() {
		this.clicked = !this.clicked;
	}

	ngOnInit(): void {
		this.transportForm();
		this.cargarComunas();
		this.facturador.updateOptionsTransport(this.optionsTransport);
	}

	obtenerInfoDisabled(): boolean {
		if (!this.transporteGroupForm.get("manejoMaderaCheckbox")?.value) {
			// Si no se selecciona "Agregar Manejo Madera", deshabilitar el botón
			return true;
		}

		const tipoBusqueda = this.transporteGroupForm.get("tipoBusqueda")?.value;

		if (tipoBusqueda === "direccion") {
			return this.transporteGroupForm.get("comunaDireccion")?.invalid || this.transporteGroupForm.get("direccionMadera")?.invalid || this.transporteGroupForm.get("numeroMadera")?.invalid;
		} else if (tipoBusqueda === "rolAvaluo") {
			return this.transporteGroupForm.get("comunaRolAvaluo")?.invalid || this.transporteGroupForm.get("rolAvaluo")?.invalid;
		}
		// Si no se ha seleccionado ningún tipo de búsqueda, deshabilitar el botón
		return true;
	}

	cargarComunas(): void {
		this.mapaService.obtenerComunas().subscribe(
			(data: Comuna[]) => {
				this.comunas = data;
				this.ref.detectChanges();
			},
			(error) => {
				console.error("Error al cargar las comunas", error);
			}
		);
	}

	abrirMapa(predio: DataPredioDireccion, mapModal): void {
		if (predio.posicionX && predio.posicionY) {
			this.latitudMapa = predio.posicionX;
			this.longitudMapa = predio.posicionY;
			this.direccionMapa = predio.direccion;
			this.mapaEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.getGoogleMapsEmbedUrl(this.latitudMapa, this.longitudMapa));
			this.modalService.open(mapModal, { size: "lg", centered: true });
		} else {
			alert("Latitud y/o Longitud no disponibles para este predio.");
		}
	}

	obtenerInformacionGeograficaDesdeDireccion(): void {
		if (this.transporteGroupForm.get("comuna")?.invalid || this.transporteGroupForm.get("direccionMadera")?.invalid || this.transporteGroupForm.get("numeroMadera")?.invalid) {
			this.transporteGroupForm.markAllAsTouched();
			return;
		}

		const comunaId = this.transporteGroupForm.get("comuna")?.value;
		const direccion = this.transporteGroupForm.get("direccionMadera")?.value;
		const numero = this.transporteGroupForm.get("numeroMadera")?.value;

		this.isLoading = true;
		//this.loadingChange.emit(true);

		this.mapaService
			.obtenerInformacionGeograficaPorDireccion(comunaId, direccion, numero)
			.pipe(
				finalize(() => {
					//this.loadingChange.emit(false);
					this.isLoading = false;
				})
			)
			.subscribe(
				(response: StandardResponse<DataPredioDireccion[]>) => {
					if (response.success) {
						if (Array.isArray(response.data) && response.data.length > 1) {
							// Múltiples predios encontrados
							this.multiplePredios = response.data;
							this.showPrediosTable = true;
							this.showManualForm = false;
							this.informacionGeografica = null;
						} else if (response.data === null || response.data.length === 0) {
							// Ningún predio encontrado
							this.showManualForm = true;
							this.showPrediosTable = false;
							this.informacionGeografica = null;
							// Asegurarse de que el formulario esté vacío y habilitado para edición
							this.transporteGroupForm.patchValue({
								mnzRolOrigen: "",
								prdRolOrigen: "",
								latitudOrigenMadera: "",
								longitudOrigenMadera: "",
								codPlanConaf: "",
							});

							// Opcional: habilitar campos que puedan haber quedado deshabilitados
							this.transporteGroupForm.get("mnzRolOrigen")?.enable();
							this.transporteGroupForm.get("prdRolOrigen")?.enable();
							this.transporteGroupForm.get("latitudOrigenMadera")?.enable();
							this.transporteGroupForm.get("longitudOrigenMadera")?.enable();
						} else {
							// Un solo predio encontrado
							this.informacionGeografica = response.data[0];
							this.showPrediosTable = false;
							this.showManualForm = false;
							this.onSubmit();
							this.transporteGroupForm.patchValue({
								mnzRolOrigen: this.informacionGeografica.manzana,
								prdRolOrigen: this.informacionGeografica.predio,
								latitudOrigenMadera: this.informacionGeografica.datosAreaHomogenea.ubicacionX,
								longitudOrigenMadera: this.informacionGeografica.datosAreaHomogenea.ubicacionY,
								codPlanConaf: "", // O ajusta según corresponda
							});
						}
					} else {
						// Manejar caso de fallo en la respuesta
						console.error("Error en la respuesta del backend:", response.message);
						// Puedes mostrar una notificación al usuario aquí
					}
					this.isLoading = false;
					this.ref.detectChanges();
				},
				(error) => {
					console.error("Error al obtener la información geográfica", error);
				}
			);
	}
	obtenerInformacionGeograficaDesdeRol(): void {
		if (this.transporteGroupForm.get("comuna")?.invalid || this.transporteGroupForm.get("rolAvaluo")?.invalid) {
			this.transporteGroupForm.markAllAsTouched();
			return;
		}

		const comunaId = this.transporteGroupForm.get("comuna")?.value;
		const rolAvaluo = this.transporteGroupForm.get("rolAvaluo")?.value;

		this.isLoading = true;
		//this.loadingChange.emit(true);

		this.mapaService
			.obtenerInformacionGeograficaPorRol(comunaId, rolAvaluo)
			.pipe(
				finalize(() => {
					//this.loadingChange.emit(false);
					this.isLoading = false;
				})
			)
			.subscribe(
				(response: StandardResponse<DataPredioDireccion>) => {
					if (response.success) {
						this.informacionGeografica = response.data;
						this.showPrediosTable = false;
						this.showManualForm = false;
						this.onSubmit();
						this.transporteGroupForm.patchValue({
							mnzRolOrigen: this.informacionGeografica.manzana,
							prdRolOrigen: this.informacionGeografica.predio,
							latitudOrigenMadera: this.informacionGeografica.posicionX,
							longitudOrigenMadera: this.informacionGeografica.posicionY,
							codPlanConaf: ""
						});
					} else {
						// Manejar caso de fallo en la respuesta
						console.error("Error en la respuesta del backend:", response.message);
						// Puedes mostrar una notificación al usuario aquí
					}
					this.isLoading = false;
					this.ref.detectChanges();
				},
				(error) => {
					console.error("Error al obtener la información geográfica", error);
					this.showManualForm = true;
					this.showPrediosTable = false;
					this.informacionGeografica = null;
					// Asegurarse de que el formulario esté vacío y habilitado para edición
					this.transporteGroupForm.patchValue({
						mnzRolOrigen: "",
						prdRolOrigen: "",
						latitudOrigenMadera: "",
						longitudOrigenMadera: "",
						codPlanConaf: "",
					});

					// Opcional: habilitar campos que puedan haber quedado deshabilitados
					this.transporteGroupForm.get("mnzRolOrigen")?.enable();
					this.transporteGroupForm.get("prdRolOrigen")?.enable();
					this.transporteGroupForm.get("latitudOrigenMadera")?.enable();
					this.transporteGroupForm.get("longitudOrigenMadera")?.enable();
				}
			);
	}
	getGoogleMapsEmbedUrl(lat: number, lng: number): string {
		return `https://www.google.com/maps/embed/v1/place?key=${environment.googleMapsApiKey}&q=${lat},${lng}&zoom=18&maptype=satellite`;
	}

	seleccionarPredio(predio: DataPredioDireccion): void {
		this.informacionGeografica = predio;
		this.showPrediosTable = false;
		this.showManualForm = false;
		this.transporteGroupForm.patchValue({
			mnzRolOrigen: predio.manzana,
			prdRolOrigen: predio.predio,
			latitudOrigenMadera: predio.posicionX,
			longitudOrigenMadera: predio.posicionY,
			codPlanConaf: "",
		});
		this.onSubmit();
	}

	transportForm() {
		this.transporteGroupForm = this.builder.group({
			rutTransporte: ["", [Validators.required, VerificacionRutValidator, Validators.maxLength(10)]],
			patente: ["", [Validators.required, Validators.maxLength(6)]],
			rutChofer: ["", [Validators.required, VerificacionRutValidator, Validators.maxLength(10)]],
			nombreChofer: ["", Validators.required],
			manejoMaderaCheckbox: [false],
			numeroMadera: [{ value: "", disabled: true }, [Validators.required, Validators.min(1)]],
			direccionMadera: [{ value: "", disabled: true }, Validators.required],
			mnzRolOrigen: [{ value: "", disabled: true }],
			prdRolOrigen: [{ value: "", disabled: true }],
			codPlanConaf: ["", []],
			latitudOrigenMadera: [{ value: "", disabled: true }],
			longitudOrigenMadera: [{ value: "", disabled: true }],
			rolAvaluo: [{ value: "", disabled: true }, [Validators.required, Validators.pattern(/^\d+-\d+$/)]],
			tipoBusqueda: [{ value: "", disabled: true }, Validators.required],
			comuna: [{ value: "", disabled: true }, Validators.required],
		});

		this.transporteGroupForm.get("manejoMaderaCheckbox")?.valueChanges.subscribe((checked) => {
			if (checked) {
				this.transporteGroupForm.get("tipoBusqueda")?.enable();
				this.transporteGroupForm.get("codPlanConaf")?.setValidators([Validators.required]);
			} else {
				this.transporteGroupForm.get("tipoBusqueda")?.disable();
				this.transporteGroupForm.get("tipoBusqueda")?.reset();
				this.transporteGroupForm.get("codPlanConaf")?.clearValidators();
				// Deshabilitar y resetear todos los campos de búsqueda
				this.deshabilitarCamposBusqueda();
			}
			this.transporteGroupForm.get("codPlanConaf")?.updateValueAndValidity();
		});

		this.transporteGroupForm.get("tipoBusqueda")?.valueChanges.subscribe((tipo) => {
			this.deshabilitarCamposBusqueda(); // Primero, deshabilitar todos los campos

			if (tipo === "direccion") {
				this.transporteGroupForm.get("comuna")?.enable();
				this.transporteGroupForm.get("direccionMadera")?.enable();
				this.transporteGroupForm.get("numeroMadera")?.enable();
			} else if (tipo === "rolAvaluo") {
				this.transporteGroupForm.get("comuna")?.enable();
				this.transporteGroupForm.get("rolAvaluo")?.enable();
			}
			this.informacionGeografica = null;
		});
	}

	private deshabilitarCamposBusqueda(): void {
		const tipoBusqueda = this.transporteGroupForm.get("tipoBusqueda")?.value;

		if (tipoBusqueda !== "direccion") {
			this.transporteGroupForm.get("direccionMadera")?.disable();
			this.transporteGroupForm.get("direccionMadera")?.reset();
			this.transporteGroupForm.get("numeroMadera")?.disable();
			this.transporteGroupForm.get("numeroMadera")?.reset();
		}

		if (tipoBusqueda !== "rolAvaluo") {
			this.transporteGroupForm.get("rolAvaluo")?.disable();
			this.transporteGroupForm.get("rolAvaluo")?.reset();
		}

		// Comuna se maneja de forma general
		if (!this.transporteGroupForm.get("tipoBusqueda")?.value) {
			this.transporteGroupForm.get("comuna")?.disable();
			this.transporteGroupForm.get("comuna")?.reset();
		}
	}

	onSubmit() {
		if (this.transporteGroupForm.valid) {
			this.optionsTransport.rutTransporte = this.transporteGroupForm.controls.rutTransporte.value ? parseInt(this.transporteGroupForm.controls.rutTransporte.value.substring(0, this.transporteGroupForm.controls.rutTransporte.value.length - 1)) : undefined;
			this.optionsTransport.patente = this.transporteGroupForm.controls.patente.value;
			this.optionsTransport.dvTransporte = this.transporteGroupForm.controls.rutTransporte.value ? this.transporteGroupForm.controls.rutTransporte.value.substring(this.transporteGroupForm.controls.rutTransporte.value.length - 1) : undefined;
			this.optionsTransport.nombreChofer = this.transporteGroupForm.controls.nombreChofer.value;
			this.optionsTransport.rutChofer = this.transporteGroupForm.controls.rutChofer.value ? parseInt(this.transporteGroupForm.controls.rutChofer.value.substring(0, this.transporteGroupForm.controls.rutChofer.value.length - 1)) : undefined;
			this.optionsTransport.dvChofer = this.transporteGroupForm.controls.rutChofer.value ? this.transporteGroupForm.controls.rutChofer.value.substring(this.transporteGroupForm.controls.rutChofer.value.length - 1) : undefined;

			this.optionsTransport.comunaOrigenId = this.transporteGroupForm.controls.comuna.value;
			this.optionsTransport.mnzRolOrigen = this.transporteGroupForm.controls.mnzRolOrigen.value;
			this.optionsTransport.prdRolOrigen = this.transporteGroupForm.controls.prdRolOrigen.value;
			this.optionsTransport.codPlanConaf = this.transporteGroupForm.controls.codPlanConaf.value;
			this.optionsTransport.latitudOrigenMadera = this.transporteGroupForm.controls.latitudOrigenMadera.value ? this.transporteGroupForm.controls.latitudOrigenMadera.value : undefined;
			this.optionsTransport.longitudOrigenMadera = this.transporteGroupForm.controls.longitudOrigenMadera.value ? this.transporteGroupForm.controls.longitudOrigenMadera.value : undefined;
			this.facturador.updateOptionsTransport(this.optionsTransport);
		} else {
			this.transporteGroupForm.markAllAsTouched();
		}
	}

	sidebar(event) {
		const toggleIcon = document.getElementById("sidebar-left");
		const toggle = document.getElementById("content-overlay");
		if (event.currentTarget.className === "sidebar-toggle d-block d-lg-none") {
			this._renderer.addClass(toggleIcon, "show");
			this._renderer.addClass(toggle, "show");
		}
	}
}
